// import user from '@/store/modules/user'
import { returnableProtocols, returnableSites } from '../../api/returned'

export default {
  "entityName": "returned",
  "upsert": "full",
  // "title": "Site request",
  "pagination": {
    "itemsPerPage": 5,
    "page": 1,
    "sortBy": "id",
    "descending": true
  },
  "fields": [
    {
      "value": "protocol_id",
      list: returnableProtocols,
      "text": "Protocol",
      "type": "autocomplete",
      "table": {
        "sortable": true,
        filter: true
      },
      "title": "name",
      validators: ['required']
    },
    {
      "value": "site_id",
      "text": "Site",
      "type": "autocomplete",
      list: returnableSites,
      "table": {
        "sortable": true,
        filter: true
      },
      "title": "name",
      subtitle: item => `${item.city} - ${item.code}`,
      deps: ['protocol_id'],
      readonly: item => !item.protocol_id,
      visible: (item, state) => state.user.role === 'Administrator' || state.user.role === 'EMN User' || state.user.role === 'Monitor',
      validators: ['required']
    },
    {
      text: 'Request Date',
      value: 'request_date',
      type: 'hidden',
      table: true,
    },
    {
      text: 'Status',
      value: 'status',
      type: 'list',
      table: true,
      visible: false
    },
    {
      type: 'alert',
      full: true,
      text: 'Enter your pick up information'
    },
    {
      text: 'Department Name',
      small: true,
      value: 'department',
      validators: ['required']
      // default 
    },    
    {
      text: 'Address',
      small: true,
      value: 'address',
      validators: ['required']
    },
    {
      text: 'Pharmacy Name',
      small: true,
      value: 'pharmacy_name',
      validators: ['required']
    },
    {
      text: 'Floor',
      small: true,
      value: 'floor',
      validators: ['required']
    },
    {
      text: 'STAIRS n. / ELEVATOR N. / ROOM N. or name / Office / OTHER',
      small: true,
      value: 'stairs',
      validators: ['required']
    },
    {
      small: true,
      text: 'Postal Code & City',
      value: 'city',
      validators: ['required']
    },
    {
      mini: true,
      text: 'Phone',
      value: 'phone',
      validators: ['required']
    },
    {
      small: true,
      text: 'E-Mail',
      value: 'email',
      validators: [
        'required',
        (field, value) => {
          if (!value) return 'E-mail is required'
          let emails = value.split(',')
          emails = emails.map(e => e.trim()).filter(e => !!e)
          if (!emails || emails.length < 2) return 'Minimum two e-mail addresses, comma separated'
          for(let v of emails) {
            if (!/.+@.+/.test(v)) return `${v} is not a valid e-mail address`
            //issue email 200 caratteri
            if ((v||'').length > 200) return `E-mail ${v} length must be <= 200 characters`
            //issue email 200 caratteri
          }
          return true
        }
      ],
    },
    {
      small: true,
      text: 'Reference',
      value: 'reference',
      validators: ['required']
    },
    {
      mini: true,
      text: 'Fax',
      value: 'fax'
    },    
    {
      small: true,
      value: 'days',
      text: 'Days available for  withdrawal',
      validators: ['required']
    },
    {
      small: true,
      value: 'hours',
      text: 'Hours available for withdrawal',
      validators: ['required']
    },
    {
      small: true,
      type: 'datetime',
      value: 'box',
      min: true,
      text: 'Package ready from',
      validators: ['required']
    },
    {
      full: true,
      value: 'note',
      text: 'Note',
      type: 'textarea',
    }
  ],
  actions: ['upsert']
}
